import { SetupIntent, PaymentIntent } from '@stripe/stripe-js'
import { getFunctions, httpsCallable } from 'firebase/functions'

class StripeService {
  subscribe = async ({
    paymentMethodId,
    referralId,
    promotionalCode,
  }: {
    paymentMethodId: string
    referralId?: string
    promotionalCode?: string
  }) => {
    const subscribe = httpsCallable<
      { paymentMethodId: string; referralId?: string; promotionalCode?: string },
      {
        intentType: 'payment' | 'setup'
        status: PaymentIntent.Status | SetupIntent.Status | 'succeeded_existing_payment_method'
        clientSecret: string | null
      }
    >(getFunctions(undefined, 'europe-west2'), 'subscribe')
    const data = await subscribe({ paymentMethodId, referralId, promotionalCode }).then(
      ({ data }) => data,
    )
    return data
  }
  topup = async () => {
    const topup = httpsCallable<null, { clientSecret: string }>(
      getFunctions(undefined, 'europe-west2'),
      'topup',
    )
    const data = await topup().then(({ data }) => data)
    return data
  }
}

export default new StripeService()
